export enum ReferenceBehavior {
  HARD = 'hard',
  WEAK = 'weak',
  DISABLED = 'disabled'
}